<div class="eg-icon-select" *transloco="let translate">
  @for (item of items; track item) {
    <div
      class="eg-icon-select__item"
      [class.eg-icon-select__item--selected]="item.value === value"
      [fxFlex]="100 / items.length"
      fxLayout="row"
      fxLayoutAlign="center center"
      (click)="onItemSelect(item)"
    >
      <img
        [ngClass]="{ 'svg-to-light-grey': item.iconName === 'trip_drop' }"
        class="eg-icon-select__icon"
        src="/assets/icons/{{ item.iconName }}.svg"
        alt="{{ item.iconName }}"
      />
      <!-- @TODO: Add icons for edit and delete here -->
    </div>
  }
</div>
